import { render, staticRenderFns } from "./CreditNotes.vue?vue&type=template&id=e825ad4e"
import script from "./CreditNotes.vue?vue&type=script&lang=js"
export * from "./CreditNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports